import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { MessageSource, MESSAGE_TYPE } from '../models/Message.model';
import * as fromActions from './messages.actions';
import * as fromReducer from './messages.reducer';
import * as fromSelector from './messages.selectors';
import { GbmConversationsStore } from './store/gbmConversations.store';
import { NotificationsStore } from './store/notifications.store';
import { LeadsStore } from './store/leads.store';
import { ReviewsStore } from './store/reviews.store';

@Injectable()
export class MessagesStore {
  constructor(
    public store: Store<fromReducer.MessagesState>,
    public gbmConversationsStore: GbmConversationsStore,
    public leadsStore: LeadsStore,
    public reviewsStore: ReviewsStore,
    public notificationsStore: NotificationsStore
  ) {}

  get state$() {
    return this.store.select(fromSelector.getState);
  }

  get filteredItems$() {
    return this.store.select(fromSelector.getFilteredItems);
  }

  get filteredSources$() {
    return this.store.select(fromSelector.getFilteredSources);
  }

  get selectedId$() {
    return this.store.select(fromSelector.getSelectedId);
  }

  filterMessagesByReadStatus(criteria: MESSAGE_TYPE) {
    this.store.dispatch(
      fromActions.filterMessagesByReadStatusBeginAction({
        messageType: criteria,
      })
    );
  }

  filterMessagesBySource(
    sorting: 'ASC' | 'DESC' = 'ASC',
    sources: MessageSource[]
  ) {
    this.store.dispatch(
      fromActions.filterMessagesBySourceBeginAction({ sorting, sources })
    );
  }

  /* get FilteredMessages$() {
    return this.store.select(fromSelector.getFilteredMessages);
  }

  MessageById$(messageId: number) {
    this.store.dispatch(fromActions.selectMessageAction({ messageId }));
    return this.store.select(fromSelector.getMessageById);
  } */

  sortMessages(messageList: any, order: 'ASC' | 'DESC') {
    return messageList.sort((a, b) => {
      const aTime =
        a.source === MessageSource.GBM_MESSAGES
          ? (a as any).updateTime
          : a.createTime;
      const bTime =
        b.source === MessageSource.GBM_MESSAGES
          ? (b as any).updateTime
          : b.createTime;

      return order === 'ASC'
        ? bTime.localeCompare(aTime)
        : aTime.localeCompare(bTime);
    });
  }
}
